import { t } from 'ember-intl'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import { on } from '@ember/modifier'
import Component from '@glimmer/component'
import { subscriptionTypeToThemeKey } from 'teacher-ui-client/utils/themes'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import UiButtonLinkTo from 'teacher-ui-client/components/ui-button/link-to'
import UiButton from 'teacher-ui-client/components/ui-button'
import ThemedModal, {
  CloseButton,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'teacher-ui-client/components/base/themed-modal'

interface Signature {
  Element: HTMLElement
  Args: {
    showModal: boolean
    fromSubscriptionType: SubscriptionType
    toSubscriptionType: SubscriptionType
    classCount: number
    onClose: () => void
  }
}

export class SuccessModal extends Component<Signature> {
  get themeKey() {
    return subscriptionTypeToThemeKey(this.args.toSubscriptionType)
  }

  <template>
    <ThemedModal @show={{@showModal}} @close={{@onClose}}>
      <ModalHeader @themeKey={{this.themeKey}}>
        <PhosphorIcon @icon="phosphor-check-circle-fill" class="mr-3 h-8 w-8" />
        <h3>
          {{t "components.copyClasses.successModal.heading"}}</h3>
        <CloseButton @close={{@onClose}} />
      </ModalHeader>
      <ModalBody>
        <p>
          {{t
            "components.copyClasses.successModal.summary"
            htmlSafe=true
            count=@classCount
            fromSubscriptionType=(t @fromSubscriptionType)
            toSubscriptionType=(t @toSubscriptionType)
          }}<br />
          {{t "components.copyClasses.successModal.manageClassesCta"}}
        </p>
      </ModalBody>
      <ModalFooter class="space-x-2 text-right">
        <UiButton data-test-copy-more {{on "click" @onClose}} @appearance={{ButtonAppearance.muted}}>
          {{t "components.copyClasses.successModal.copyMoreClasses"}}
        </UiButton>
        <UiButtonLinkTo data-test-manage-classes @appearance={{ButtonAppearance.regular}} @route="manage.classes">
          {{t "components.copyClasses.successModal.manageClasses"}}
        </UiButtonLinkTo>
      </ModalFooter>
    </ThemedModal>
  </template>
}
